import { render, staticRenderFns } from "./ContactDetailsForm.vue?vue&type=template&id=56def87d&scoped=true&"
import script from "./ContactDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsForm.vue?vue&type=style&index=0&id=56def87d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56def87d",
  null
  
)

export default component.exports